import { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import {
  getPendingProjectInvitations,
  respondToProjectInvitation,
} from "../api/userApi";

export default function PendingInvitationsCard() {
  const queryClient = useQueryClient();
  const [respondingId, setRespondingId] = useState(null);

  const { data: invitations = [], isLoading } = useQuery({
    queryKey: ["project-invitations-pending"],
    queryFn: () => getPendingProjectInvitations().then((r) => r.data || []),
  });

  const respondMutation = useMutation({
    mutationFn: ({ id, action }) => respondToProjectInvitation(id, action),
    onSuccess: (_, { action }) => {
      toast.success(action === "accept" ? "Invitation accepted" : "Invitation declined");
      queryClient.invalidateQueries({ queryKey: ["project-invitations-pending"] });
      queryClient.invalidateQueries({ queryKey: ["projects"] });
    },
    onError: (err) => {
      toast.error(err.response?.data?.message || "Could not update invitation");
    },
    onSettled: () => setRespondingId(null),
  });

  if (isLoading || invitations.length === 0) return null;

  return (
    <div
      style={{
        marginBottom: 16,
        padding: "14px 16px",
        borderRadius: 12,
        border: "1px solid #a9ddf5",
        background: "#EAF6FD",
      }}
    >
      <div style={{ fontWeight: 800, fontSize: "0.9rem", color: "#2C63AE", marginBottom: 8 }}>
        Project invitations
      </div>
      {invitations.map((inv) => (
        <div
          key={inv.id}
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: 10,
            padding: "8px 0",
            borderTop: "1px solid #EAF6FD",
          }}
        >
          <div style={{ flex: "1 1 200px", minWidth: 0 }}>
            <div style={{ fontWeight: 700, color: "#0f172a", fontSize: "0.88rem" }}>
              {inv.projectname || inv.project_id}
            </div>
            <div style={{ fontSize: "0.78rem", color: "#64748b" }}>
              From {inv.invited_by_name || "a teammate"}
              {inv.message ? ` — ${inv.message}` : ""}
            </div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button
              type="button"
              disabled={respondingId === inv.id}
              onClick={() => {
                setRespondingId(inv.id);
                respondMutation.mutate({ id: inv.id, action: "accept" });
              }}
              style={{
                padding: "6px 12px",
                borderRadius: 8,
                border: "none",
                background: "#2C63AE",
                color: "#fff",
                fontWeight: 700,
                fontSize: "0.8rem",
                cursor: "pointer",
              }}
            >
              Accept
            </button>
            <button
              type="button"
              disabled={respondingId === inv.id}
              onClick={() => {
                setRespondingId(inv.id);
                respondMutation.mutate({ id: inv.id, action: "decline" });
              }}
              style={{
                padding: "6px 12px",
                borderRadius: 8,
                border: "1px solid #cbd5e1",
                background: "#fff",
                color: "#475569",
                fontWeight: 600,
                fontSize: "0.8rem",
                cursor: "pointer",
              }}
            >
              Decline
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
